import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import canamLogo from './images/CanAm Logo.png';
import './styles/App.css';

// Context
import { AppProvider } from './context/AppContext';

// Components
import Tabs from './components/Tabs';
import { useApp } from './context/AppContext';

// Pages
import InvitePage from './pages/InvitePage';
import RSVPPage from './pages/RSVPPage';
import GuestListPage from './pages/GuestListPage';
import VideoPage from './pages/VideoPage';
import GamesPage from './pages/GamesPage';
import PhotosPage from './pages/PhotosPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';

function AppShell() {
  const { loading, error, loadData } = useApp();

  if (loading) {
    return (
      <div className="App">
        <header className="App-header">
          <Link to="/invite" className="header-home-link">
            <img src={canamLogo} alt="CanAm Logo" className="header-logo" />
            <h1>CanAm Games</h1>
          </Link>
        </header>
        <div className="App-main" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="welcome"><p>Loading...</p></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <header className="App-header">
          <Link to="/invite" className="header-home-link">
            <img src={canamLogo} alt="CanAm Logo" className="header-logo" />
            <h1>CanAm Games</h1>
          </Link>
        </header>
        <div className="App-main" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="welcome">
            <h2 style={{ color: '#c62828' }}>Connection Error</h2>
            <p>{error}</p>
            <button className="submit-btn" style={{ marginTop: '1.5rem', maxWidth: 200 }} onClick={loadData}>
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <Link to="/invite" className="header-home-link">
          <img src={canamLogo} alt="CanAm Logo" className="header-logo" />
          <h1>CanAm Games</h1>
        </Link>
      </header>

      <div className="App-layout">
        <Tabs />
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Navigate to="/invite" replace />} />
            <Route path="/invite" element={<InvitePage />} />
            <Route path="/rsvp" element={<RSVPPage />} />
            <Route path="/guests" element={<GuestListPage />} />
            <Route path="/video" element={<VideoPage />} />
            <Route path="/photos" element={<PhotosPage />} />
            <Route path="/games" element={<GamesPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
      </div>

      <footer className="App-footer">
        <p>CanAm Event &copy; {new Date().getFullYear()}</p>
        <p className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <span className="footer-sep">·</span>
          <Link to="/terms">Terms &amp; Conditions</Link>
        </p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <Router>
        <AppShell />
      </Router>
    </AppProvider>
  );
}

export default App;
